import { render, staticRenderFns } from "./RanksAndRewards.vue?vue&type=template&id=3a08fe58&scoped=true&"
import script from "./RanksAndRewards.vue?vue&type=script&lang=js&"
export * from "./RanksAndRewards.vue?vue&type=script&lang=js&"
import style0 from "./RanksAndRewards.vue?vue&type=style&index=0&id=3a08fe58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a08fe58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a08fe58')) {
      api.createRecord('3a08fe58', component.options)
    } else {
      api.reload('3a08fe58', component.options)
    }
    module.hot.accept("./RanksAndRewards.vue?vue&type=template&id=3a08fe58&scoped=true&", function () {
      api.rerender('3a08fe58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff-engagement/components/RanksAndRewards.vue"
export default component.exports